<app-header></app-header>



<main>
  <!-- <p>main layout</p> -->
  <router-outlet></router-outlet>
</main>
<!-- 
<app-footer></app-footer> -->